export const mockLiveStreams = [
  // 星宮つむぎ (vtuberId: '1')
  {
    id: '101',
    vtuberId: '1',
    videoId: 'mock_video_001',
    title: '【ホラーゲーム】新作を初見プレイ！',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live101',
    startedAt: '2026-07-30T21:00:00+09:00',
    duration: 7200,
    category: 'game',
    highlightSeconds: 4500,
  },
  {
    id: '102',
    vtuberId: '1',
    videoId: 'mock_video_101',
    title: '【ホラーゲーム】激ムズ実績コンプ企画',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live102',
    startedAt: '2026-07-25T21:00:00+09:00',
    duration: 6600,
    category: 'game',
    highlightSeconds: 3000,
  },
  {
    id: '103',
    vtuberId: '1',
    videoId: 'mock_video_102',
    title: '【概要欄必読】新作ホラーゲーム発表',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live103',
    startedAt: '2026-07-18T21:30:00+09:00',
    duration: 5400,
    category: 'game',
    highlightSeconds: 2400,
  },

  // 藍原ルナ (vtuberId: '2')
  {
    id: '201',
    vtuberId: '2',
    videoId: 'mock_video_002',
    title: '【歌枠】リクエスト曲を歌う夜',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live201',
    startedAt: '2026-07-27T20:00:00+09:00',
    duration: 5400,
    category: 'singing',
    highlightSeconds: 3300,
  },
  {
    id: '202',
    vtuberId: '2',
    videoId: 'mock_video_201',
    title: '【歌枠】新曲カバー披露',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live202',
    startedAt: '2026-07-20T20:00:00+09:00',
    duration: 5000,
    category: 'singing',
    highlightSeconds: 2200,
  },
  {
    id: '203',
    vtuberId: '2',
    videoId: 'mock_video_202',
    title: '【歌枠】雨の日ver.しっとり歌枠',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live203',
    startedAt: '2026-07-13T20:00:00+09:00',
    duration: 4800,
    category: 'singing',
    highlightSeconds: 1800,
  },

  // 黒崎テツヤ (vtuberId: '3')
  {
    id: '301',
    vtuberId: '3',
    videoId: 'mock_video_003',
    title: '【雑談】最近あったことをだらだら話す',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live301',
    startedAt: '2026-07-31T22:00:00+09:00',
    duration: 6000,
    category: 'talk',
    highlightSeconds: 4200,
  },
  {
    id: '302',
    vtuberId: '3',
    videoId: 'mock_video_301',
    title: '【雑談】深夜テンションで質問答える',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live302',
    startedAt: '2026-07-28T22:00:00+09:00',
    duration: 5800,
    category: 'talk',
    highlightSeconds: 2600,
  },
  {
    id: '303',
    vtuberId: '3',
    videoId: 'mock_video_302',
    title: '【雑談】週末の出来事を振り返る',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live303',
    startedAt: '2026-07-24T22:00:00+09:00',
    duration: 6200,
    category: 'talk',
    highlightSeconds: 3600,
  },

  // 雪代みかん (vtuberId: '4')
  {
    id: '401',
    vtuberId: '4',
    videoId: 'mock_video_004',
    title: '【新作ゲーム】発売日凸配信！',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live401',
    startedAt: '2026-08-01T19:00:00+09:00',
    duration: 7800,
    category: 'game',
    highlightSeconds: 5200,
  },
  {
    id: '402',
    vtuberId: '4',
    videoId: 'mock_video_401',
    title: '【歌枠】お祝い記念ライブ',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live402',
    startedAt: '2026-07-27T19:00:00+09:00',
    duration: 5200,
    category: 'singing',
    highlightSeconds: 1900,
  },
  {
    id: '403',
    vtuberId: '4',
    videoId: 'mock_video_402',
    title: '【ゲーム実況】協力プレイ配信',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live403',
    startedAt: '2026-07-26T19:00:00+09:00',
    duration: 7000,
    category: 'game',
    highlightSeconds: 4700,
  },

  // 緑川そら (vtuberId: '5')
  {
    id: '501',
    vtuberId: '5',
    videoId: 'mock_video_005',
    title: '【まったり雑談】週末のんびりタイム',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live501',
    startedAt: '2026-07-26T18:00:00+09:00',
    duration: 4200,
    category: 'talk',
    highlightSeconds: 1500,
  },
  {
    id: '502',
    vtuberId: '5',
    videoId: 'mock_video_501',
    title: '【歌枠】癒しの弾き語り',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live502',
    startedAt: '2026-07-19T18:00:00+09:00',
    duration: 4000,
    category: 'singing',
    highlightSeconds: 2100,
  },
  {
    id: '503',
    vtuberId: '5',
    videoId: 'mock_video_502',
    title: '【雑談】読書感想会',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live503',
    startedAt: '2026-07-12T18:00:00+09:00',
    duration: 3900,
    category: 'talk',
    highlightSeconds: 1200,
  },

  // 朱雀アカネ (vtuberId: '6')
  {
    id: '601',
    vtuberId: '6',
    videoId: 'mock_video_006',
    title: '【格闘ゲーム】ランクマ配信',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live601',
    startedAt: '2026-07-25T23:00:00+09:00',
    duration: 7200,
    category: 'game',
    highlightSeconds: 5400,
  },
  {
    id: '602',
    vtuberId: '6',
    videoId: 'mock_video_601',
    title: '【格闘ゲーム】新キャラ検証配信',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live602',
    startedAt: '2026-07-18T23:00:00+09:00',
    duration: 6800,
    category: 'game',
    highlightSeconds: 3900,
  },
  {
    id: '603',
    vtuberId: '6',
    videoId: 'mock_video_602',
    title: '【対戦ゲーム】視聴者参加型大会',
    thumbnailUrl: 'https://placehold.co/320x180?text=Live603',
    startedAt: '2026-07-11T23:00:00+09:00',
    duration: 8000,
    category: 'game',
    highlightSeconds: 6100,
  },
];
